import { useEffect, useRef, useState } from 'react'
import { useAnmeldung } from '../lib/anmeldung'
import { PasswortAendern } from './PasswortAendern'
import { Einstellungen } from './Einstellungen'
import { Hilfe } from './Hilfe'

/* Ein Buchstabe, nicht zwei: aus "Sven Schütt" wuerde sonst "SS", und das
   geht in Deutschland nicht. */
function kuerzel(name: string): string {
  return name.trim()[0]?.toUpperCase() ?? ''
}

/**
 * Das eigene Konto. Alles, was den Menschen betrifft und nicht die Arbeit,
 * liegt hier: Passwort, Einstellungen der Kanzlei, Abmelden.
 */
export function Profilmenue() {
  const { auskunft, abmelden } = useAnmeldung()
  const [offen, setzeOffen] = useState(false)
  const [passwortOffen, setzePasswortOffen] = useState(false)
  const [einstellungenOffen, setzeEinstellungenOffen] = useState(false)
  const [hilfeOffen, setzeHilfeOffen] = useState(false)
  const bereich = useRef<HTMLDivElement>(null)
  const knopf = useRef<HTMLButtonElement>(null)

  useEffect(() => {
    if (!offen) return
    const beiKlick = (ereignis: MouseEvent) => {
      if (!bereich.current?.contains(ereignis.target as Node)) setzeOffen(false)
    }
    const beiTaste = (ereignis: KeyboardEvent) => {
      if (ereignis.key === 'Escape') {
        setzeOffen(false)
        knopf.current?.focus()
      }
    }
    document.addEventListener('mousedown', beiKlick)
    document.addEventListener('keydown', beiTaste)
    return () => {
      document.removeEventListener('mousedown', beiKlick)
      document.removeEventListener('keydown', beiTaste)
    }
  }, [offen])

  if (!auskunft) return null
  const verwaltung = auskunft.benutzer.rolle === 'verwaltung'

  return (
    <div className="profil" ref={bereich}>
      <button
        ref={knopf}
        type="button"
        className="profil-knopf"
        aria-haspopup="menu"
        aria-expanded={offen}
        onClick={() => setzeOffen((war) => !war)}
      >
        <span className="benutzerkreis">{kuerzel(auskunft.benutzer.name)}</span>
        <span className="profil-text">{auskunft.benutzer.name}</span>
        <span className="profil-pfeil" aria-hidden="true" />
      </button>

      {offen && (
        <div className="profil-menue" role="menu">
          <div className="profil-kopf">
            <div className="benutzername">{auskunft.benutzer.name}</div>
            <div className="benutzerrolle">{auskunft.benutzer.email}</div>
            <div className="benutzerrolle">{verwaltung ? 'Verwaltung' : auskunft.kanzlei}</div>
          </div>

          {!verwaltung && (
            <button
              type="button"
              role="menuitem"
              className="profil-eintrag"
              onClick={() => {
                setzeOffen(false)
                setzeEinstellungenOffen(true)
              }}
            >
              Einstellungen der Kanzlei
            </button>
          )}

          <button
            type="button"
            role="menuitem"
            className="profil-eintrag"
            onClick={() => {
              setzeOffen(false)
              setzePasswortOffen(true)
            }}
          >
            Passwort ändern
          </button>

          <button
            type="button"
            role="menuitem"
            className="profil-eintrag"
            onClick={() => {
              setzeOffen(false)
              setzeHilfeOffen(true)
            }}
          >
            Hilfe: Datei in DATEV einlesen
          </button>

          <div className="profil-trenner" />

          <button type="button" role="menuitem" className="profil-eintrag abmelden" onClick={() => void abmelden()}>
            Abmelden
          </button>
        </div>
      )}

      <PasswortAendern offen={passwortOffen} aufSchliessen={() => setzePasswortOffen(false)} />
      <Hilfe offen={hilfeOffen} aufSchliessen={() => setzeHilfeOffen(false)} />
      {!verwaltung && <Einstellungen offen={einstellungenOffen} aufSchliessen={() => setzeEinstellungenOffen(false)} />}
    </div>
  )
}
